import moment from "moment";
import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import DefaultTooltipContent from "recharts/lib/component/DefaultTooltipContent";
import styled from "styled-components";

const PieContainer = styled.div``;

const LegendWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 30px;
`;

const LegendItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  min-width: 100px;
`;

const LegendTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
`;

const LegendDot = styled.div`
  background-color: ${(props) => props.color ?? "#000"};
  height: 14px;
  width: 14px;
  border-radius: 7px;
  margin-right: 5px;
`;

const CustomTooltip = (props) => {
  // payload[0] doesn't exist when tooltip isn't visible
  if (props.payload[0] != null) {
    const newPayload = [
      {
        value: props.payload[0].payload.letter,
      },
      {
        value: props.payload[0].payload.info,
      },
    ];

    if (props.payload[0].payload.subInfo) {
      newPayload.push({
        value: props.payload[0].payload.subInfo,
      });
    }

    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
  }

  // we just render the default
  return <DefaultTooltipContent {...props} />;
};

const CustomLegend = (props) => {
  const { payload } = props;

  return (
    <LegendWrapper>
      {payload
        ?.filter((entry) => entry.payload.isVisible)
        .map((entry, index) => (
          <LegendItemWrapper key={`item-${index}`}>
            <LegendTitleWrapper>
              <LegendDot color={entry.color} />
              <span>{entry.value}</span>
            </LegendTitleWrapper>

            {entry.payload.info && <span>{entry.payload.info}</span>}
            {entry.payload.subInfo && <span>{entry.payload.subInfo}</span>}
          </LegendItemWrapper>
        ))}
    </LegendWrapper>
  );
};

const CustomPieChart = (props) => {
  const { series, width, height, customKey = "pie-chart" } = props;

  return (
    <PieContainer key={customKey} data-testid="pie-chart" className="pie-chart">
      <PieChart key={moment().toISOString()} width={width} height={height + 20}>
        <Pie
          isAnimationActive={false}
          data={series.filter((item) => item.frequency > 0)}
          nameKey="letter"
          dataKey="frequency"
        >
          {series.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip separator="" content={<CustomTooltip />} />
        <Legend
          verticalAlign="bottom"
          align="left"
          iconType="circle"
          content={<CustomLegend />}
          wrapperStyle={{ width: "auto", left: 46 }}
        />
      </PieChart>
    </PieContainer>
  );
};

export default CustomPieChart;
